import * as z from 'zod';

import { StopSettings } from '../loan/StopSettings';
import { BaseLoanEvent } from './BaseLoanEvent';

export const UpdateStopSettingsEvent = BaseLoanEvent.extend({
  type: z.literal('updateStopSettings'),
  stopSettings: StopSettings,
  previousStopSettings: StopSettings.optional(), // optional b/c the initial event didn't include but we want to capture changes made for the audit log
});
export type UpdateStopSettingsEvent = z.infer<typeof UpdateStopSettingsEvent>;
